import { useState } from 'react'

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false)

  function openModal() {
    setIsShowing(true)
  }

  function closeModal() {
    setIsShowing(false)
  }

  return {
    openModal,
    closeModal,
    isShowing
  }
}

export default useModal
